import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/CreateUser.css';
import api from '../utils/axiosConfig';

function CreateUser() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    email: '',
    institute: '',
    role: '',
    password: '',
    rpassword: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle user creation logic here
    // Client-side validation
    if (formData.password !== formData.rpassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await api.post('/api/users', formData);

      navigate('/dashboard/users/user-creation-success');
    } catch (err) {
      // Get server-provided error message if available
      setError(err.response?.data?.message || 'Could not create user');
      console.error('Error:', err);
    }

   
  };

  return (
    <div className="create-user-container">
      <div className="create-user-card">
        <h1>Neuen Benutzer erstellen</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          {/* Add your form fields here */}
          <div className="form-group">
          <label htmlFor="code">Code</label>
            <input 
              type="text" 
              id="code" 
              value={formData.code}
              onChange={handleChange}
              pattern="[1-9]{5}[PT]"
              maxLength="6"
              title="Format: 5 digits (1-9) followed by P or T (e.g., 13579P)"
              placeholder="12345P"
            />
          </div>
          <div className="form-group">
          <label htmlFor="name">Vollständiger Name</label>
            <input 
              type="text" 
              id="name" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-Mail</label>
            <input 
              type="email" 
              id="email" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="institute">Institut/Schule</label>
            <input 
              type="text" 
              id="institute" 
              value={formData.institute}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="role">Rolle</label>
            <select 
              id="role"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="">Bitte auswählen</option>
              <option value="admin">Admin</option>
              <option value="teacher">Lehrkraft</option>
              <option value="parent">Elternteil</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input 
              type="password" 
              id="password" 
              value={formData.password}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="rpassword">Passwort wiederholen</label>
            <input 
              type="password" 
              id="rpassword" 
              value={formData.rpassword}
              onChange={handleChange}
              required />
          </div>
          <div className="button-group">
            <button type="submit" className="submit-button">
              Benutzer erstellen
            </button>
            <button 
              type="button" 
              className="cancel-button"
              onClick={() => navigate('/dashboard/users')}
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUser;